module.exports = __webpack_public_path__ + "static/IBMPlexMono-Italic-e013d7fb192edf9a162083034de4c4dc.woff2";